import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { articles } from "@/mocks/news";

const stats = [
  { value: String(movies.length), label: "收录影片" },
  { value: "10", label: "覆盖年份" },
  { value: "8", label: "影片类型" },
  { value: String(articles.length), label: "影评与资讯" },
];

export default function ArchiveIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="relative">
            <div className="h-[260px] w-full overflow-hidden rounded-lg bg-secondary-200 md:h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20vintage%20film%20archive%20room%20with%20wooden%20shelves%20of%20film%20reels%2C%20a%20classic%20projector%20casting%20a%20warm%20light%20beam%2C%20dust%20in%20the%20air%2C%20painted%20retro%20cinematic%20illustration%2C%20burgundy%20amber%20and%20cream%20palette%2C%20film%20grain%2C%20no%20text&width=900&height=700&seq=archive-projector-room&orientation=landscape"
                alt="八十年代电影资料室与放映机"
                title="80s电影 资料室"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-4 rounded-md border border-background-200 bg-background-50 px-4 py-3 md:left-6">
              <p className="font-label text-[10px] uppercase tracking-[0.24em] text-secondary-600">
                Total Archive
              </p>
              <p className="mt-1 font-heading text-2xl font-semibold text-primary-700">
                {movies.length} 部影片 · {articles.length} 篇文章
              </p>
            </div>
          </div>

          <div>
            <p className="mb-2 flex items-center gap-2 font-label text-[12px] uppercase tracking-[0.24em] text-primary-600">
              <span className="inline-block h-[1px] w-6 bg-accent-500"></span>
              关于这个档案
            </p>
            <h2 className="font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-3xl">
              把八十年代的电影，重新摆回书架
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              80s电影不是影讯聚合站，而是一个由影迷维护的资料档案。我们关心影片的拍摄年份、导演、片长，也关心它在四十年后还剩下多少值得讨论的东西。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              所有条目都按统一体例整理：先给出影片事实，再给出剧情概要，最后才是编辑部的观点。你可以不同意我们的判断，但至少能清楚看到判断的依据。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-x-4 gap-y-5 sm:grid-cols-4">
              {stats.map((item) => (
                <div key={item.label} className="border-l border-background-300 pl-3">
                  <p className="font-heading text-2xl font-semibold text-primary-700 md:text-3xl">
                    {item.value}
                  </p>
                  <p className="mt-1 text-xs text-secondary-600">{item.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-700 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-800"
            >
              了解编辑原则
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}